export const prerender = 'auto';